import { type CanvasElementFrom, type WithSlots } from '@blaze-runtime/engine-domain';

import { registerElementDefinition } from '../../services/element-definitions.service';

import { OverlayComponent } from './_overlay.component';

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    _overlay: OverlayDef;
  }
}

export const OVERLAY_SLOT = 'main';

export type OverlayDef = WithSlots<typeof OVERLAY_SLOT>;
export type OverlayElement = CanvasElementFrom<'_overlay'>;

registerElementDefinition({
  type: '_overlay',
  componentType: OverlayComponent,
  isListed: false,
  name: 'Overlay',
  width: { mode: 'full' },
  slots: {
    ids: [OVERLAY_SLOT],
    [OVERLAY_SLOT]: { children: [] },
  },
  version: 1,
});
